import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../shared/services/http/user/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService, private authService: AuthService, private httpService: UserService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.authService.getAuthorizationToken();
    if (!authToken) return next.handle(req.clone());
    if (authToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
      });
    }

    return next.handle(req).pipe(
      catchError((error: any) => {
        console.log('error', error);

        if (error.code === 401) {
          return this.handle401Error(req, next);
        }
        if (error.code === 403) {
          return this.handle401Error(req, next);
        }
        return throwError(() => (error ? error : new Error('Something bad happened; please try again later.')));
      }),
    );
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('begain refresh token', req);

    return this.httpService
      .refreshToken({
        token: this.authService.getToken(),
        refreshToken: this.authService.getRefreshToken(),
      })
      .pipe(
        switchMap((newToken: any) => {
          console.log(newToken.data);
          this.cookieService.set('X-Auth-Token', newToken.data.token, 30, '/', undefined, true, 'Lax');
          this.cookieService.set('X-Auth-RefreshToken', newToken.data.refreshToken, 30, '/', undefined, true, 'Lax');
          // Clone the failed request with the new token
          const clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken.data.token}`,
            },
          });
          return next.handle(clonedRequest);
        }),
        catchError((err) => {
          if (err) {
            this.authService.logout();
          }
          return throwError(() => new Error('Session expired. Please log in again.'));
        }),
      );
  }
}
